import * as types from "./types";

const favoritesReducer = (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_ALL_FAVORITES_REQUEST:
      return {
        ...state
      };
    case types.FETCH_ALL_FAVORITES_SUCCESS:
      const favoritesData = (action.payload && action.payload.data) || {};
      const favorites = Object.keys(favoritesData).reduce(
        (acc, key) => {
          acc[key] = favoritesData[key].isFavorited;
          return acc;
        },
        { ...state.favorites }
      );
      return {
        ...state,
        favorites: favorites
      };
    case types.FETCH_ALL_FAVORITES_FAILURE:
      return {
        ...state
      };
    case types.ADD_FAVORITES_REQUEST:
      return {
        ...state
      };
    case types.ADD_FAVORITES_SUCCESS:
      return {
        ...state,
        favorites: {
          ...state.favorites,
          [action.payload]: true
        }
      };
    case types.ADD_FAVORITES_FAILURE:
      return {
        ...state
      };
    case types.DELETE_FAVORITES_REQUEST:
      return {
        ...state
      };
    case types.DELETE_FAVORITES_SUCCESS:
      return {
        ...state,
        favorites: {
          ...state.favorites,
          [action.payload]: false
        }
      };
    case types.DELETE_FAVORITES_FAILURE:
      return {
        ...state
      };
    default:
      return state;
  }
};

export default favoritesReducer;
